import { SearchAppliedPtosParams, SearchDistributionsParams, SearchPromoCodeParams } from 'Modules'

export const promoCodeKeys = {
  all: ['promoCodes'] as const,
  lists: () => [...promoCodeKeys.all, 'list'] as const,
  list: (params: SearchPromoCodeParams) => [...promoCodeKeys.lists(), params] as const,
  details: () => [...promoCodeKeys.all, 'detail'] as const,
  detail: (id: string | undefined) => [...promoCodeKeys.details(), id] as const,
  appliedPtos: (id: string | undefined, params: SearchAppliedPtosParams) =>
    [...promoCodeKeys.detail(id), 'applied-ptos', params] as const,
  distributions: (id: string | undefined, params: SearchDistributionsParams) =>
    [...promoCodeKeys.detail(id), 'distributions', params] as const,
  existingUsers: (keyword?: string) => [...promoCodeKeys.all, 'existing-users', keyword] as const,
}
